import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { CheckCircle2, ArrowLeft } from "lucide-react";

// Thank You page is ONLY in Spanish, at /thank_you
const ThankYou = () => {
  useEffect(() => {
    document.title = "Gracias — Inversionandes";
    document.documentElement.lang = "es-EC";
  }, []);

  return (
    <section
      data-testid="thankyou-page"
      className="flex-1 flex items-center justify-center bg-[#0B1120] py-24 px-5"
    >
      <div className="max-w-2xl w-full text-center">
        <div className="inline-flex h-16 w-16 items-center justify-center rounded-full bg-emerald-600/15 border border-emerald-600/40 mb-6">
          <CheckCircle2 size={30} className="text-emerald-400" />
        </div>
        <span className="text-xs font-mono uppercase tracking-widest text-emerald-400">
          Solicitud recibida
        </span>
        <h1 className="mt-4 text-4xl sm:text-5xl font-extrabold tracking-tight text-white">
          ¡Gracias por tu solicitud!
        </h1>
        <p className="mt-5 text-slate-300 text-lg leading-relaxed">
          Hemos recibido correctamente tu información. Un responsable podrá ponerse en contacto
          contigo para facilitarte información adicional sobre los siguientes pasos.
        </p>
        <p className="mt-3 text-sm text-slate-500 leading-relaxed">
          Las solicitudes se procesan por orden de recepción. El servicio tiene fines exclusivamente
          informativos y no garantiza resultados concretos.
        </p>
        <Link
          to="/"
          data-testid="thankyou-back-home"
          className="mt-8 inline-flex items-center gap-2 px-6 py-3 rounded-md bg-emerald-600 hover:bg-emerald-700 text-white text-sm font-semibold"
        >
          <ArrowLeft size={16} /> Volver al inicio
        </Link>
      </div>
    </section>
  );
};

export default ThankYou;
